import { useAuth } from '@neotech-solutions-org/neofusion-fe-shared';
import { useCallback, useMemo } from 'react';
import { PERMISSIONS, Permission, USER_ROLES } from '../constants/roles';
import { ROLE_PERMISSION_MAP } from '../constants/roles';

export const useRoles = () => {
  const user = useAuth();

  const hasPermission = useCallback(
    (permission: Permission) => {
      return user?.permissions?.includes(PERMISSIONS[permission]) ?? false;
    },
    [user]
  );

  const role = useMemo(() => {
    const foundRole = ROLE_PERMISSION_MAP.find((item) => hasPermission(item.permission));

    return foundRole ? foundRole.role : USER_ROLES.PLAYER;
  }, [hasPermission]);

  const isSuperAdmin = role === USER_ROLES.SUPER_ADMIN;
  const isAdmin = role === USER_ROLES.ADMIN;
  const isManager = role === USER_ROLES.MANAGER;
  const isAgent = role === USER_ROLES.AGENT;
  const isTrader = role === USER_ROLES.TRADER;
  const isTechSupport = role === USER_ROLES.TECH_SUPPORT;
  const isPlayer = role === USER_ROLES.PLAYER;

  return {
    hasPermission,
    role,
    isSuperAdmin,
    isAdmin,
    isManager,
    isAgent,
    isTrader,
    isTechSupport,
    isPlayer,
  };
};
